import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { OpptyProbability } from '../models/types/oppty_probability';
import { JobProcess } from '../models/types/job_process';
import { OpptyStatus } from '../models/types/oppty_status';
import { OpptyStage } from '../models/types/oppty_stage';
import { OpptyProgress } from '../models/types/oppty_progress';
import { environment } from '../../../environments/environment';
import { Observer } from 'rxjs';

@Injectable()
export class OpportunityTypeService {
    constructor(private http: HttpClient) {}
    getAllOpptyTypes() {
        let refDataObservable=Observable.create((observer:Observer<any>)=>{
            setTimeout(() => {
                observer.next("Probability")
            }, 10
            )
            setTimeout(() => {
                observer.next("Status")
            }, 20
            )
            setTimeout(() => {
                observer.next("Stage")
            }, 30
            )
            setTimeout(() => {
                observer.next("Progress")
            }, 40
            )
            setTimeout(() => {
                observer.next("JobProcess")
            }, 50
            )
        });
        refDataObservable.subscribe(data=>{
            if(data == 'Probability'){
                this.getProbability();
            }else if(data == 'Status'){
                this.getStatus();
            }else if(data == 'Stage'){
                this.getStage();
            }else if(data == 'Progress'){
                this.getProgress();
            }else if(data == 'JobProcess'){
                this.getJobprocess();
            }
        });
        // this.getProbability();
        // this.getStatus();
        // this.getStage();
        // this.getProgress();
        // this.getJobprocess();
    }
    getProbability() {
        this.http.get<OpptyProbability>(`${environment.api}probability_ratio`)
        .subscribe(res => {
            sessionStorage.setItem('opptyprobability', JSON.stringify(res['data']));
          //
        });
    }
    getJobprocess(){
        this.http.get<JobProcess>(`${environment.api}job_process`)
        .subscribe(res => {
            sessionStorage.setItem('jobprocess', JSON.stringify(res['data']));
          //
        });
    }
    getStatus() {
        this.http.get<OpptyStatus>(`${environment.api}oppty_statustype`)
        .subscribe(res => {
            sessionStorage.setItem('opptystatus', JSON.stringify(res['data']));
          //
        });
    }
    getStage() {
        this.http.get<OpptyStage>(`${environment.api}stage`)
        .subscribe(res => {
            sessionStorage.setItem('opptystage', JSON.stringify(res['data']));
          //
        });
    }
    getProgress() {
        this.http.get<OpptyProgress>(`${environment.api}progress`)
        .subscribe(res =>{
            sessionStorage.setItem('opptyprogress',JSON.stringify(res['data']));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/opportunity-type.service.ts